import React from 'react';

import { Container } from './styles';
import { FileState } from '../../reducer';
import { Button } from 'ui-components/src/components/atoms/Button';

export const FileUploadActions = ({
  uploadState,
  onClose,
  onUpload,
}: FileUploadActionsProps) => {
  const readyToUpload = hasFilesReadyToUpload(uploadState);
  const isUploading = hasFilesUploading(uploadState);

  return (
    <Container>
      <Button secondary onClick={onClose} disabled={isUploading}>
        {readyToUpload || isUploading ? 'Cancel' : 'Close'}
      </Button>
      {readyToUpload && (
        <Button onClick={onUpload} loading={isUploading}>
          Upload
        </Button>
      )}
    </Container>
  );
};

function hasFilesUploading(uploadState: FileState[]): boolean {
  return uploadState.some((item) => item.status === 'UPLOADING');
}

function hasFilesReadyToUpload(uploadState: FileState[]): boolean {
  return uploadState.some((item) => item.status === 'READY');
}

export interface FileUploadActionsProps {
  isUploading: boolean;
  uploadState: FileState[];
  onClose?: () => void;
  onUpload: () => void;
}
